import { Outlet, Navigate } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { useAuthStore } from '@/stores/authStore';

interface AdminLayoutProps {
  children?: React.ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  const { user } = useAuthStore();

  // Check if user has admin role
  const isAdmin = user?.role === 'Admin' || user?.role === 'SuperAdmin' || user?.role === 'Support';

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-dark-900">
      <AdminSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="h-16 border-b border-gray-200 dark:border-dark-700 bg-white dark:bg-dark-800 flex items-center justify-between px-6">
          <div className="flex items-center gap-2">
            <span className="px-2 py-1 text-xs font-medium bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 rounded">
              Admin Panel
            </span>
          </div>
          <div className="text-sm text-gray-500 dark:text-gray-400">
            Logged in as <span className="font-medium text-gray-900 dark:text-white">{user?.email}</span>
          </div>
        </header>
        <main className="flex-1 overflow-y-auto p-6">
          {children || <Outlet />}
        </main>
      </div>
    </div>
  );
}
